module.exports = __webpack_public_path__ + "img/5.cbad044c.jpg";